import { LinearProgress, List, makeStyles } from "@material-ui/core";
import React, { Fragment } from "react";
import LinkIcon from "@material-ui/icons/Link";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { combineProps } from "../../../../helpers/objectHelper";
import { Input, Label, Row, Col } from "reactstrap";
import DeleteIcon from "@material-ui/icons/Delete";
import FolderIcon from "@material-ui/icons/Folder";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import { FileType } from "./FileType";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    maxWidth: "100%",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    minHeight: "calc(100vh - 179px)",
    maxHeight: "calc(100vh - 179px)",
    overflowY: "auto",
    overflowX: "hidden",
  },
  demo2: {
    backgroundColor: theme.palette.background.paper,
    overflowY: "auto",
    maxHeight: "calc(100vh  - 179px)",
    minHeight: "calc(50vh - 156px)",
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  progress: {
    position: "absolute",
    width: "87%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const File = (props) => {
  const classes = useStyles();
  const { settings, onEdit, onDelete, setSavable, onUpload, name, value, exhibitorSettingId, deleteList, value2, isLoading, target } = props;
  return (
    <Row
      style={{
        padding: "10px 10px 5px 10px",
        margin: "0px 10px",
      }}
    >
      <Col className="col-2" style={{ padding: 0 }}>
        <FileType value={value2} />
      </Col>
      <Col className="col-4">
        <Input
          onChange={(e) => {
            onEdit(exhibitorSettingId, "value", e.target.value);
            setSavable(true);
          }}
          value={value}
        />
      </Col>
      <Col className="col-4" style={{ display: "inline-flex" }}>
        {target && target == exhibitorSettingId && isLoading ? (
          <div className={classes.progress}>
            <LinearProgress />
          </div>
        ) : null}
        <Input
          readOnly={name == "File"}
          onChange={(e) => {
            onEdit(exhibitorSettingId, "value2", e.target.value);
            setSavable(true);
          }}
          value={value2}
        />
      </Col>
      <Col className="col-2">
        <input accept="pdf,doc,docx,xls,xlsx,png,jpg,ppt,pptx" id={`file-upload-${exhibitorSettingId}`} className="file-upload" type="file" onChange={(e) => onUpload(e, exhibitorSettingId, name)} />
        <label htmlFor={`file-upload-${exhibitorSettingId}`} className="mock-button">
          <FolderIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
        </label>
        {"  "}
        <label
          className="mock-button"
          onClick={() => {
            onDelete(exhibitorSettingId);
            setSavable(true);
          }}
        >
          {deleteList.find((d) => d.exhibitorSettingId == exhibitorSettingId) ? (
            <SettingsBackupRestoreIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          ) : (
            <DeleteIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          )}
        </label>
      </Col>
    </Row>
  );
};

const Link = (props) => {
  const classes = useStyles();
  const { settings, onEdit, onDelete, setSavable, onUpload, name, exhibitorSettingId, deleteList, value2, value, isLoading, target } = props;
  return (
    <Row
      style={{
        padding: "10px 10px 5px 10px",
        margin: "0px 10px",
      }}
    >
      <Col className="col-2" style={{ padding: 0 }}>
        <LinkIcon />
      </Col>
      <Col className="col-4">
        <Input
          onChange={(e) => {
            onEdit(exhibitorSettingId, "value", e.target.value);
            setSavable(true);
          }}
          value={value}
        />
      </Col>
      <Col className="col-4" style={{ display: "inline-flex" }}>
        {target && target == exhibitorSettingId && isLoading ? (
          <div className={classes.progress}>
            <LinearProgress />
          </div>
        ) : null}
        <Input
          readOnly={name == "File"}
          onChange={(e) => {
            onEdit(exhibitorSettingId, "value2", e.target.value);
            setSavable(true);
          }}
          value={value2}
        />
      </Col>
      <Col className="col-2">
        <input
          accept="pdf,doc,docx,xls,xlsx,png,jpg,ppt,pptx"
          id={`file-upload-${exhibitorSettingId}`}
          className="file-upload"
          type="file" /* multiple */
          onChange={(e) => onUpload(e, exhibitorSettingId, name)}
        />

        {name != "Link" ? (
          <label htmlFor={`file-upload-${exhibitorSettingId}`} className="mock-button">
            <FolderIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          </label>
        ) : null}
        {"  "}
        <label
          className="mock-button"
          onClick={() => {
            onDelete(exhibitorSettingId);
            setSavable(true);
          }}
        >
          {deleteList.find((d) => d.exhibitorSettingId == exhibitorSettingId) ? (
            <SettingsBackupRestoreIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          ) : (
            <DeleteIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          )}
        </label>
      </Col>
    </Row>
  );
};

export const AttachmentSettings = (props) => {
  const { settings, onEdit, setSavable } = props;
  return (
    <List
      className="booth-settings-list"
      style={{
        padding: 10,
        maxHeight: "calc(100vh - 157px)",
        minHeight: "calc(100vh - 157px)",
        overflowX: "hidden",
      }}
    >
      <div className="category-header">
        <Row>
          <Col className="col-2 ">
            <EventLabel2 name="Links" groupName="Exhibitor.Admin" />
          </Col>
          <Col className="col-4">
            <EventLabel2 name="DisplayText" groupName="Exhibitor.Admin" />
          </Col>{" "}
          <Col className="col-4">
            <EventLabel2 name="Url" groupName="Exhibitor.Admin" />
          </Col>
        </Row>
      </div>
      {settings.filter((s) => s.name == "Link").length > 0 ? (
        settings
          .filter((s) => s.name == "Link")
          .sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          })
          .map((s, i) => {
            return (
              <Fragment key={s.exhibitorSettingId}>
                <Link {...combineProps([props, s])} />
              </Fragment>
            );
          })
      ) : (
        <Row>
          <Col className="col-4 "></Col>
          <Col className="col-4 text-center">
            <EventLabel2 name="NoLinks" groupName="Exhibitor.Admin" />
          </Col>
          <Col className="col-4"></Col>
        </Row>
      )}
      <div className="category-header">
        <Row>
          <Col className="col-2 ">
            <EventLabel2 name="Files" groupName="Exhibitor.Admin" />
          </Col>
          <Col className="col-4">
            <EventLabel2 name="DisplayText" groupName="Exhibitor.Admin" />
          </Col>{" "}
          <Col className="col-4">
            <EventLabel2 name="Url" groupName="Exhibitor.Admin" />
          </Col>
        </Row>
      </div>
      {settings.filter((s) => s.name == "File").length > 0 ? (
        settings
          .filter((s) => s.name == "File")
          .sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          })
          .map((s, i) => {
            return (
              <Fragment key={s.exhibitorSettingId}>
                <File {...combineProps([props, s])} />
              </Fragment>
            );
          })
      ) : (
        <Row>
          <Col className="col-4 "></Col>
          <Col className="col-4 text-center">
            <EventLabel2 name="NoFiles" groupName="Exhibitor.Admin" />
          </Col>
          <Col className="col-4"></Col>
        </Row>
      )}
    </List>
  );
};
